
import { RemoteResult, IdRequest } from "mangdto"
import MainLogic from "@/logic/main_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class ImpressumFiliale extends Vue {
  logic: ImpressumFilialeLogic = null

  mounted() {
    this.logic = new ImpressumFilialeLogic()
    this.logic.init(MainLogic.getInstance().filiale.filialeId)
  }
}

class ImpressumFilialeLogic {
  impressum: string

  init(id: string) {
    var request = new IdRequest()
    request.id = id

    Poster.postMember<RemoteResult<string>>(
      RestPaths.filialeImpressum,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.impressum = response.data.payload
      }
    })
  }
}
